import { twMerge } from '@/styles/tailwindMergeConfig'

import { Options } from './Options'
import { PopoverReviewers } from './PopeverReviewers'
import { Avatar, Scrollarea } from '@/components'

import { useBreakpoint } from '@/hooks/useBreakpoint'
import { useReportOptions } from '@/hooks/reports/useReportOptions'

export function Responsible() {
  const { reportOptions } = useReportOptions()

  const [isLg] = useBreakpoint('lg')

  
  return (
    <div
      className={twMerge(
        'bg-cromai-m3-sys-light-surface-variant text-cromai-m3-sys-light-on-background',
        'dark:bg-cromai-m3-sys-dark-surface-variant dark:text-cromai-m3-sys-dark-on-background',
        ' flex min-h-[400px] w-full flex-col items-start overflow-auto rounded px-6 py-4 font-mono text-labelLarge lg:h-full'
      )}
    >
      <div className="w-full ">
        {isLg ? (
          <PopoverReviewers
            side="left"
            align="start"
            sideOffset={36}
            alignOffset={-52}
          />
        ) : (
          <PopoverReviewers
            side="bottom"
            align="end"
            sideOffset={-110}
            alignOffset={-20}
          />
        )}
      </div>
      <Scrollarea className="w-full overflow-hidden">
        {reportOptions.notifiedPeople.map((notifiedPerson) => {
          return (
            <div
              key={notifiedPerson.userId}
              className="mb-2 flex w-full items-center rounded bg-cromai-m3-sys-light-background py-2 pl-4 pr-2 dark:bg-cromai-m3-sys-dark-background"
            >
              <div className="mr-auto flex items-center gap-2">
                <Avatar size="small" name={notifiedPerson.userName} />
                <span className="max-w-44 truncate">{notifiedPerson.userName}</span>
              </div>

              <Options notifiedPerson={notifiedPerson} />
            </div>
          )
        })}
      </Scrollarea>
    </div>
  )
}
